import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTruckClass } from '@/features/truck-classes/api'

import { truckClassParamsSchema } from '../-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/truck-classes/$truckClassId'
)({
  parseParams: (params) => parse(truckClassParamsSchema, params),
  loader: async ({
    params: { tenantKey, truckClassId },
    context: { auth }
  }) => {
    const truckClass = await fetchTruckClass({ tenantKey, truckClassId })
    return {
      truckClass,
      authUser: auth.user
    }
  },
  meta: ({ loaderData }) => [{ title: loaderData.truckClass.name }]
})
